import { openUploadModal, useFeatureDispatch } from '../lib/state'
import { UserDocument } from '../lib/userDocuments.slice'

import { useAnalyticsTrack } from '@/features/amplitude'
import { Button } from '@/ui'

interface UploadRequiredDocumentButtonProps {
  document: UserDocument
}

export const UploadRequiredDocumentButton = ({
  document,
}: UploadRequiredDocumentButtonProps) => {
  const dispatch = useFeatureDispatch()
  const track = useAnalyticsTrack()

  const openModal = () => {
    track('clicked document upload', {
      document_category: document.documentType || '',
      document_subcategory: document.userDocumentCategoryId || '',
    })
    dispatch?.(
      openUploadModal(
        document.documentType || '',
        document.userDocumentCategoryId,
        undefined, // descriptionType
        document
      )
    )
  }
  return (
    <Button onClick={openModal} variant="secondary">
      Upload
    </Button>
  )
}
